<app-modal
  [activeModal]="activeModal"
  [isCloseDisabled]="form.pristine || !form.valid || isSaving"
  [onClose]="submit"
  [title]="title"
>
  <app-domain-error class="mb-6"></app-domain-error>

  <form [formGroup]="form">
    <div class="mb-6">
      <label for="nazwa-grupy-input" class="form-label" i18n>Nazwa</label>
      <input
        type="text"
        autocomplete="off"
        class="form-control"
        [ngClass]="isControlValid('nazwa')"
        id="nazwa-grupy-input"
        [maxlength]="maksDlugoscNazwyGrupyOdbiorcow"
        formControlName="nazwa"
      />
      <small class="invalid-feedback" i18n>To pole jest wymagane.</small>
      <app-text-counter
        [currentLength]="form.get('nazwa').value?.length"
        [maxLength]="maksDlugoscNazwyGrupyOdbiorcow"
      ></app-text-counter>
    </div>

    <div *ngIf="!recordData" class="mb-6">
      <label for="odbiorcy-select" class="form-label" i18n>Odbiorcy</label>
      <app-sss-select
        [displayOnlyFirstProperty]="true"
        [dataSource]="uzytkownicySource"
        [inputId]="'odbiorcy-select'"
        [reactiveControl]="form.get('odbiorcaIds')"
        [displayProperty]="['nazwa', 'email']"
        [isMultiple]="true"
      >
      </app-sss-select>
      <small class="form-text text-danger" *ngIf="shouldDisplayTypeOfError('odbiorcaIds', 'required')" i18n>
        To pole jest wymagane.
      </small>
    </div>
  </form>
</app-modal>
